export const FETCH = 'FETCH'
export const UPDATE_FILES = 'UPDATE_FILES'
export const INITIAL_SETUP = 'INITIAL_SETUP'
export const GET_SIMILARITY = 'GET_SIMILARITY'